namespace Matrix.Navigation {
    export interface FullTextSearchRequest extends Serenity.ServiceRequest {
        SearchTerm?: string;
    }
}
